import locale from './locale'
import reporter from './reporter'

const env = 'dev'
const config = {
  thaiairways: {
    serverUrl: 'https://thaiairways.herokuapp.com/',
    appid: '710306462496316'
  },
  dev: {
    serverUrl: 'https://api-enterprise.zwiz.app/',
    webhookUrl: 'https://webhook-enterprise.zwiz.app/',
    appid: '324115987996476'
  }
}

export default {
  serverUrl: config[env].serverUrl,
  webhookUrl: config[env].webhookUrl,
  facebookUrl: 'https://graph.facebook.com/',
  shopUrl: 'https://shop.enterprise.zwiz.app/',
  appid: config[env].appid,
  sentry_dsn: 'https://7259cd9fb1024494894184ab2560895c@o946970.ingest.sentry.io/5908212',

  theme: {
    logo: '/static/img/logo-egg-digital.png',
    small_logo: '/static/img/logo-egg-digital.png',
    short_small_logo: '/static/img/logo-egg-digital.png',
    hide_zwiz: false,
    email_contact: 'sales@zwiz.ai',
    header_color: 'white',
    header_background_color: '#504F4F',
    brand_color: '#FDB813', // #ed1839    Default is #FF706B
    secondary_color: '#ff687f' // #ff687f
  },

  fb_scope:
    'email,pages_show_list,read_page_mailboxes,pages_messaging,page_events,pages_read_engagement,pages_manage_metadata,pages_read_user_content,pages_manage_ads,pages_manage_posts,pages_manage_engagement,public_profile,instagram_basic,instagram_manage_messages,instagram_manage_comments,ads_management,ads_read',

  reporter: reporter,
  locale: locale.locale
}



// WEBPACK FOOTER //
// ./src/config/index.js